import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";

export const useAdmin = () => {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);

  useEffect(() => {
    if (!loading) { // AuthContext এর লোডিং শেষ হলেই চেক করুন
      if (user) {
        setIsAdmin(user.role === "admin");
        setIsSuperAdmin(user.role === "superadmin");
      } else {
        setIsAdmin(false);
        setIsSuperAdmin(false);
      }
      setAdminLoading(false);
    }
  }, [user, loading]);

  return { isAdmin, isSuperAdmin, isLoading: loading || adminLoading };
};